function addIconToFormTitle() {
  const iconContainer = document.getElementById('contact-section-icon');
  const formTitle = document.querySelector('.bcontact-title');
  
  if (iconContainer && formTitle) {
    const iconClone = iconContainer.cloneNode(true);
    iconClone.removeAttribute('id');
    iconClone.removeAttribute('style');
    iconClone.className = 'contact-form-icon';
    
    formTitle.insertBefore(iconClone, formTitle.firstChild);
  } else {
    setTimeout(addIconToFormTitle, 100);
  }
}

function customizeSelectArrow() {
  const selectWrappers = document.querySelectorAll('.bcontact_select_wrapper');
  
  if (selectWrappers.length > 0) {
    selectWrappers.forEach(wrapper => {
      if (!wrapper.querySelector('.custom-arrow-icon')) {
        const arrowIcon = document.createElement('span');
        arrowIcon.className = 'custom-arrow-icon';
        arrowIcon.innerHTML = '<svg width="9" height="5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m7.75.75-3.5 3-3.5-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        wrapper.appendChild(arrowIcon);
      }
    });
  } else {
    setTimeout(customizeSelectArrow, 100);
  }
}

function initContactForm() {
  addIconToFormTitle();
  customizeSelectArrow();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContactForm);
} else {
  initContactForm();
}
